import styled from '@emotion/styled'
import { hexColors } from '@mobi/settings'

export const DateSelectionLabelStyled = styled.label({
  display: 'block',
  color: hexColors.dimGrey,
  fontSize: '1.2rem',
})
